import { render, staticRenderFns } from "./jiliangServiceDetail.vue?vue&type=template&id=514cdd7c&scoped=true"
import script from "./jiliangServiceDetail.vue?vue&type=script&lang=js"
export * from "./jiliangServiceDetail.vue?vue&type=script&lang=js"
import style0 from "./jiliangServiceDetail.vue?vue&type=style&index=0&id=514cdd7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514cdd7c",
  null
  
)

export default component.exports